import { Button, Card } from 'antd';
import { styled } from 'styled-components';

export const DetailCard = styled(Card)`
  width: 100%;
  min-width: 0;

  > .ant-card-head {
    padding-inline: 16px;

    .ant-card-head-wrapper {
      flex-wrap: wrap;
      gap: 12px 24px;
      padding-block: 16px;
    }

    .ant-card-head-title {
      min-width: 180px;
      padding: 0;
      white-space: normal;
    }

    .ant-card-extra {
      margin-inline-start: auto;
      padding: 0;
    }
  }

  @media (max-width: 640px) {
    > .ant-card-head .ant-card-extra {
      width: 100%;
      margin-inline-start: 0;
    }
  }
`;

export const MetadataSection = styled.dl`
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  margin: 0;
`;

export const MetadataItem = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  max-width: 320px;

  &:not(:last-child) {
    padding-inline-end: 16px;
    border-inline-end: 1px solid #e4e9f0;
  }

  dt {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 5px;
    margin: 0;
    color: ${({ theme }) => theme.gray};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  dt .anticon {
    color: ${({ theme }) => theme.lightText};
    font-size: 14px;
  }

  dd {
    min-width: 0;
    min-height: 24px;
    margin: 0;
    color: ${({ theme }) => theme.primaryBg};
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    overflow-wrap: anywhere;
  }

  .ant-tag {
    margin: 0;
    padding: 1px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
`;

export const SupportingActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 8px;

  > .ant-space {
    max-width: 100%;
  }

  > [role='status'] .ant-tag {
    margin-inline-end: 0;
  }
`;

export const DetailMessages = styled.div`
  display: grid;
  gap: 12px;
  margin-bottom: 16px;
  overflow-wrap: anywhere;

  &:empty {
    display: none;
  }

  @media (max-width: 640px) {
    > .ant-alert {
      flex-wrap: wrap;
      row-gap: 12px;
    }
  }
`;

export const ValidationSummary = styled.div`
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;

export const IssueList = styled.ul`
  margin: 0;
  padding-left: 20px;

  li + li {
    margin-top: 4px;
  }

  & + details {
    margin-top: 12px;
  }
`;

export const IssueButton = styled(Button)`
  height: auto;
  padding: 0;
  white-space: normal;
  text-align: left;
`;

export const TabSection = styled.section`
  display: grid;
  gap: 16px;
  min-width: 0;
`;
